import { Controller } from "@hotwired/stimulus"

// flashメッセージの表示制御（自動非表示・閉じるボタン）
export default class extends Controller {
  static targets = ["message"]

  connect() {
    // 5秒後に自動で閉じる
    this.messageTargets.forEach((message) => {
      this.scheduleAutoClose(message)
    })
  }

  close(event) {
    if (event) event.preventDefault()

    const message = event?.currentTarget.closest('[data-flash-target="message"]') || this.messageTarget
    this.fadeOut(message)
  }

  // 外部から動的にflashメッセージを追加する
  addMessage(type, text) {
    const cssClass = type === "notice" || type === "success"
      ? "bg-[#d1e7dd] border-[#75b798] text-[#0a3622]"
      : "bg-[#f8d7da] border-[#ea868f] text-[#ce0000]"

    const role = type === "alert" || type === "error" ? "alert" : "status"

    const box = document.createElement("div")
    box.setAttribute("role", role)
    box.setAttribute("data-flash-target", "message")
    box.className = `${cssClass} border rounded-[6px] p-[16px] text-[16px] flex items-start justify-between gap-[8px]`

    const span = document.createElement("span")
    span.textContent = text

    const btn = document.createElement("button")
    btn.type = "button"
    btn.setAttribute("data-action", "flash#close")
    btn.className = "shrink-0 ml-auto text-current opacity-50 hover:opacity-100 text-[20px] leading-none cursor-pointer"
    btn.setAttribute("aria-label", "閉じる")
    btn.innerHTML = "&times;"

    box.appendChild(span)
    box.appendChild(btn)
    this.element.appendChild(box)

    this.scheduleAutoClose(box)
  }

  disconnect() {
    this.messageTargets.forEach((message) => {
      const timerId = message.dataset.flashTimerId
      if (timerId) clearTimeout(Number(timerId))
    })
  }

  // private

  scheduleAutoClose(message) {
    const timerId = setTimeout(() => {
      this.fadeOut(message)
    }, 5000)
    message.dataset.flashTimerId = timerId
  }

  fadeOut(message) {
    const timerId = message.dataset.flashTimerId
    if (timerId) clearTimeout(Number(timerId))

    message.style.transition = "opacity 0.3s ease"
    message.style.opacity = "0"
    setTimeout(() => message.remove(), 300)
  }
}
